import { render, staticRenderFns } from "./UnitSearchAndSelectionPanel.vue?vue&type=template&id=644f5a7f"
import script from "./UnitSearchAndSelectionPanel.vue?vue&type=script&lang=js"
export * from "./UnitSearchAndSelectionPanel.vue?vue&type=script&lang=js"
import style0 from "./UnitSearchAndSelectionPanel.vue?vue&type=style&index=0&id=644f5a7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports